// src/App.js
// import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// import { AnimatePresence } from 'framer-motion';

// ===================================
// Import Komponen Layout
// ===================================
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import PageTransitionWrapper from './components/layout/PageTransitionWrapper';
import ScrollToTop from './components/layout/ScrollToTop';
import NotFound from './components/common/NotFound';
import Maintenance from './components/common/Maintenance'
// import LoadingSpinner from './components/common/LoadingSpinner';

// ===================================
// Import Halaman-halaman Utama
// ===================================
import Home from './pages/Home';
import BeritaDuka from './pages/BeritaDuka';

import AbsensiIbadahPelkat from './pages/AbsensiIbadahPelkat';
// import AbsensiPA from './pages/absensi-pelkat/pa';
import AbsensiPT from './pages/absensi-pelkat/pt';
import AbsensiGP from './pages/absensi-pelkat/gp';
// import AbsensiPKP from './pages/absensi-pelkat/pkp';
// import AbsensiPKB from './pages/absensi-pelkat/pkb';
// import AbsensiPKLU from './pages/absensi-pelkat/pklu';

import WartaJemaat from './pages/WartaJemaat';
import WartaDetails from './pages/warta-jemaat/WartaDetails';
import TataIbadah from './pages/TataIbadahs';
import TataIbadahDetails from './pages/tata-ibadah/TataIbadahDetails';

// import Fungsionaris from './pages/Fungsionaris';
import Phmj from './pages/fungsionaris/Phmj';
import KontakKorsek from './pages/fungsionaris/KontakKorsek';
import PengurusPelkat from './pages/fungsionaris/PengurusPelkat';
import Presbiter from './pages/fungsionaris/Presbiter';
import Komisi from './pages/fungsionaris/Komisi';

import FormulirIndex from './pages/formulir/FormulirIndex';
import FormulirPage from './pages/formulir/FormulirPage';

import Sejarah from './pages/Sejarah';
import VisiMisiGpib from './pages/sejarah/VisiMisi';
import KepemimpinanKmj from './pages/sejarah/Kmj';
// import Vikaris from './pages/sejarah/Vikaris';

// ===================================
// Komponen Utama AppContent
// ===================================
const AppContent = () => {
  const location = useLocation();

  return (
    <div className="bg-gray-100 min-h-screen font-sans flex flex-col">
      <Header />
      <div className="flex-grow">
        {/* <AnimatePresence mode="wait"> */}
        <Routes location={location} key={location.pathname}>
          {/* =================================== */}
          {/* Rute Halaman Umum */}
          {/* =================================== */}
          <Route path="/" element={<PageTransitionWrapper><Home /></PageTransitionWrapper>} />
          <Route path="/berita-duka" element={<PageTransitionWrapper><BeritaDuka /></PageTransitionWrapper>} />
          {/* <Route path="/absensi-pelkat" element={<PageTransitionWrapper><AbsensiIbadahPelkat /></PageTransitionWrapper>} /> */}
          <Route path="*" element={<PageTransitionWrapper><NotFound /></PageTransitionWrapper>} />

          {/* =================================== */}
          {/* Rute Warta Jemaat */}
          {/* =================================== */}
          <Route path="/warta-jemaat" element={<PageTransitionWrapper><WartaJemaat /></PageTransitionWrapper>} />
          <Route path="/warta-jemaat/:id" element={<PageTransitionWrapper><WartaDetails /></PageTransitionWrapper>} />

          {/* =================================== */}
          {/* Rute Tata Ibadah */}
          {/* =================================== */}
          <Route path="/tata-ibadah" element={<PageTransitionWrapper><TataIbadah /></PageTransitionWrapper>} />
          <Route path="/tata-ibadah/:type/:subType?/:id" element={<PageTransitionWrapper><TataIbadahDetails /></PageTransitionWrapper>} />

          {/* =================================== */}
          {/* Rute Bakti Sosial */}
          {/* =================================== */}
          {/* <Route path="/bakti-sosial" element={<PageTransitionWrapper><BaktiSosial /></PageTransitionWrapper>} /> */}

          {/* =================================== */}
          {/* Rute Absensi Ibadah Pelkat */}
          {/* =================================== */}
          <Route path="/absensi-pelkat" element={<PageTransitionWrapper><AbsensiIbadahPelkat /></PageTransitionWrapper>} />
          <Route path="/absensi-pelkat/pa" element={<PageTransitionWrapper><Maintenance /></PageTransitionWrapper>} />
          <Route path="/absensi-pelkat/pt" element={<PageTransitionWrapper><AbsensiPT /></PageTransitionWrapper>} />
          <Route path="/absensi-pelkat/gp" element={<PageTransitionWrapper><AbsensiGP /></PageTransitionWrapper>} />
          <Route path="/absensi-pelkat/pkp" element={<PageTransitionWrapper><Maintenance /></PageTransitionWrapper>} />
          <Route path="/absensi-pelkat/pkb" element={<PageTransitionWrapper><Maintenance /></PageTransitionWrapper>} />
          <Route path="/absensi-pelkat/pklu" element={<PageTransitionWrapper><Maintenance /></PageTransitionWrapper>} />

          {/* =================================== */}
          {/* Rute Informasi Fungsionaris */}
          {/* =================================== */}
          {/* <Route path="/fungsionaris" element={<PageTransitionWrapper><Fungsionaris /></PageTransitionWrapper>} /> */}
          <Route path="/fungsionaris/phmj" element={<PageTransitionWrapper><Phmj /></PageTransitionWrapper>} />
          <Route path="/fungsionaris/kontak-korsek" element={<PageTransitionWrapper><KontakKorsek /></PageTransitionWrapper>} />
          <Route path="/fungsionaris/pengurus-pelkat" element={<PageTransitionWrapper><PengurusPelkat /></PageTransitionWrapper>} />
          <Route path="/fungsionaris/presbiter" element={<PageTransitionWrapper><Presbiter /></PageTransitionWrapper>} />
          <Route path="/fungsionaris/komisi" element={<PageTransitionWrapper><Komisi /></PageTransitionWrapper>} />

          {/* =================================== */}
          {/* Rute Formulir */}
          {/* =================================== */}
          <Route path="/formulir" element={<FormulirIndex />} />
          <Route path="/formulir/:slug" element={<FormulirPage />} />

          {/* =================================== */}
          {/* Rute Sejarah & Kepemimpinan */}
          {/* =================================== */}
          <Route path="/sejarah" element={<PageTransitionWrapper><Sejarah /></PageTransitionWrapper>} />
          <Route path="/sejarah/visi-misi" element={<PageTransitionWrapper><VisiMisiGpib /></PageTransitionWrapper>} />
          <Route path="/sejarah/kepemimpinan-kmj" element={<PageTransitionWrapper><KepemimpinanKmj /></PageTransitionWrapper>} />
          <Route path="/sejarah/vikaris" element={<PageTransitionWrapper><Maintenance /></PageTransitionWrapper>} />
        </Routes>
        {/* </AnimatePresence> */}
      </div>
      <Footer />
    </div>
  );
};

// ===================================
// Komponen Root App
// ===================================
const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
};

export default App;